import { Component, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { WestnetzSidenavService } from '../../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { MatSidenav } from '@angular/material/sidenav';

@Component({
    selector: 'redispatch-westnetz-page',
    templateUrl: './westnetz-page.component.html',
    styleUrls: [
        './westnetz-page.component.scss',
    ],
    standalone: false,
})
export class WestnetzPageComponent {

    @ViewChild('right', { static: true }) right: MatSidenav;
    @ViewChild('rightTemplate', { read: ViewContainerRef, static: true }) rightTemplateContainer: ViewContainerRef;

    private westnetzSidenavService = inject(WestnetzSidenavService);

    constructor() {
        this.westnetzSidenavService.openRightnav$.subscribe(component => {
            this.rightTemplateContainer.clear();
            this.rightTemplateContainer.createComponent(component);
            // noinspection JSIgnoredPromiseFromCall
            this.right.open();
        });

        this.westnetzSidenavService.closeRightnav$.subscribe(() => {
            this.right.close().then(() => {
                if (!this.right.opened) {
                    this.rightTemplateContainer.clear();
                }
            });
        });
    }
}
